import * as React           from "react";

import "./ad-budget-table.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {UseState}               from "@Common/react/use-state";
import {DataTableD1}            from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {getPageSummary}         from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {PageList}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PageSize}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {AD_BUDGET_PLACEHOLDER}  from "../ad-budget-defaults-route";
import {InlineAmountForm}       from "../../common/inline-amount-form/inline-amount-form";

export const AdBudgetsDefaultsTable = ({branches, getAmount, setAmount}) => cs(
    consumeContext("apis"),
    ["pageSize", (_, next) => UseState({initValue: 10, next})],
    ({apis, pageSize}) => (
        <div className="ad-budget-table-a93">
            {DataTableD1({
                paginationKey: "ad-budget",
                pageSize: pageSize.value,
                darkRows: "even",
                rows: branches?.map((branch) => ({
                    key: branch.idBranch,
                    xdQaName: branch.idBranch,
                    columns: [
                        {
                            render: () => <>
                                {branch.branchName || branch.branchLinkId}
                            </>,
                            domAttrs: {
                                "xd-qa-type": "label",
                                "xd-qa-name": branch.branchName || branch.branchLinkId + " BRANCH NAME",
                                "data-for": "branchName",
                                "data-tip": branch.branchName || branch.branchLinkId,
                            },
                            sortValue: () => branch.branchName.toLowerCase() || branch.branchLinkId.toLowerCase(),
                        },
                        {
                            render: () => InlineAmountForm({
                                amount: getAmount(branch),
                                readOnly: false,
                                onChange: async (newAmount) => {
                                    await apis.next.adBudgets.setAdBudgetDefaults([{
                                        idBranch: branch.idBranch,
                                        amount: newAmount,
                                    }]);

                                    setAmount(branch.idBranch, newAmount);
                                }
                            }),
                            domAttrs: {
                                "xd-qa-type": "icon",
                                "xd-qa-name": getAmount(branch) + " EDIT",
                            },
                        },
                    ].filter(v => v),
                })),
                columns: columns(),
                emptyAction: {
                    label: AD_BUDGET_PLACEHOLDER
                },
                getFooter: ({colCount, pagination}) => ({
                    columns: [{
                        colSpan: colCount,
                        render: () => (
                            <div className="controls">

                                {branches.length > 10 ? (
                                    PageSize({state: pageSize, xdQaNamePrefix: "Pending Orders"})
                                ) : (
                                    <div className="spacer"/>
                                )}

                                {pagination.active && PageList(pagination)}
                                {getPageSummary({
                                    pageIndex: pagination.state.value,
                                    pageSize: pageSize.value,
                                    count: branches.length
                                })}

                            </div>
                        )
                    }],
                }),
            })}
        </div>
    )
);

const columns = () => [
    {
        label: "OFFICE",
        className: "office",
        align: "left",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "OFFICE",
        },
    },
    {
        label: "AMOUNT",
        className: "amount",
        //width: "100px",
        align: "right",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "AMOUNT",
        },

    },
].filter(v => v);